module.exports = __webpack_public_path__ + "img/logo-full-mercado_pago.2fb7cd40.png";